module.exports = __webpack_public_path__ + "img/BF8E78_E5CCBF_753E32_4A261E-256px.2e588b28.png";